module.exports = __webpack_public_path__ + "static/img/trends5.0dfa3115.jpg";